import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InMemoryPdfService {

  private pdfData:Uint8Array | null = null;

constructor() { }

setPdfData(data:Uint8Array){
  this.pdfData = data;
}

getPdfData():Uint8Array | null{
  return this.pdfData;
}

}
